import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Avatar, IconButton, DropdownMenu } from "@radix-ui/themes";
import { UserInfoContext } from "context/UserInfoContext";
import api from "axios_interceptor/interceptor";
import { IsAuthenticatedContext } from "context/IsAuthenticatedContext";

const Profile = () => {
  const { setIsAuthenticated } = useContext(IsAuthenticatedContext);

  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("access_token");
    setIsAuthenticated(false);
    navigate("/login");
  };

  const { currentUserInfo, setCurrentUserInfo } = useContext(UserInfoContext);

  const fetchUserData = async () => {
    try {
      const response = await api.get("/auth/user-info");
      const data = response.data;
      if (data.content.length !== 0) setCurrentUserInfo(data.content[0]);
    } catch (error) {
      console.error("Error fetching user info:", error);
    }
  };

  useEffect(() => {
    fetchUserData();
  }, []);

  const getFallbackInitial = () => {
    return currentUserInfo && currentUserInfo.display_name
      ? currentUserInfo.display_name.charAt(0).toUpperCase()
      : "X";
  };

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger>
        <IconButton variant="soft" style={{ cursor: "pointer" }}>
          <Avatar fallback={getFallbackInitial()} />
          <DropdownMenu.TriggerIcon />
        </IconButton>
      </DropdownMenu.Trigger>
      <DropdownMenu.Content>
        <DropdownMenu.Item>
          Hello 👋 {currentUserInfo.display_name} 
        </DropdownMenu.Item>
        {/* <DropdownMenu.Item style={{ cursor: "pointer" }}>
          {currentUserInfo.email}
        </DropdownMenu.Item> */}
        {/* <DropdownMenu.Item style={{ cursor: "pointer" }}>
          Settings
        </DropdownMenu.Item> */}
        <DropdownMenu.Separator />
        <DropdownMenu.Item
          color="red"
          onClick={handleLogout}
          style={{ cursor: "pointer" }}
        >
          Log out
        </DropdownMenu.Item>
      </DropdownMenu.Content>
    </DropdownMenu.Root>
  );
};

export default Profile;
